import { Command } from './command.model';
import { Operation } from './operation.model';

export class OperationWithCommand extends Operation {
    currentCommand!: Command;
}
